<script>
import VueDatePicker from 'vue2-datepicker';
import zhCN from 'vue2-datepicker/locale/zh-cn';

VueDatePicker.name = 'date-picker'
VueDatePicker.props.lang.default = () => zhCN

export default VueDatePicker
</script>
<style lang="scss">
@import '~vue2-datepicker/scss/index.scss';

.mx-datepicker-main {
  background-color: inherit;
}
.mx-datepicker {
  &.mx-datepicker-range {
    width: 100%;
  }
  .mx-input-wrapper {
    input {
      padding: 0.7rem;
      height: 16px;
      box-sizing: content-box;
      box-shadow: 0 0 0 0 rgba(0,0,0,.15);
      border: 1px solid rgba(0,0,0,.2);
      width: calc(100% - 1.4rem);
    }
  }
}
.mx-datepicker-body {
  .mx-table-date {
    thead tr th {
      text-align: center;
    }
  }
}
</style>